module.exports = __webpack_public_path__ + "static/media/tv.dad64b28.svg";